import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {AlmacenService} from "../../../services/api/almacen.service";
import {FormIngresoService} from "../../../services/forms/form-ingreso.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import Swal from "sweetalert2";

@Component({
  selector: 'app-dialog-inventario-menajeria',
  templateUrl: './dialog-inventario-menajeria.component.html',
  styleUrls: ['./dialog-inventario-menajeria.component.css']
})
export class DialogInventarioMenajeriaComponent implements OnInit {

  menajeriaForm!:FormGroup;
  estado:any;
  menajeriaId:any;

  constructor(private router: Router, private fb: FormBuilder, private almacenService:AlmacenService ,private formService: FormIngresoService ,
              public dialogRef: MatDialogRef<DialogInventarioMenajeriaComponent>, @Inject(MAT_DIALOG_DATA) public data:any,
  ) {

  }

  ngOnInit(): void {
    this.menajeriaForm = this.fb.group({
      menajeria: this.formService.getMenajeriaForm()
    });

    this.menajeriaForm.get(['menajeria','nombre'])?.setValue(this.data.nombre);
    this.menajeriaForm.get(['menajeria','marca'])?.setValue(this.data.marca);
    this.menajeriaForm.get(['menajeria','modelo'])?.setValue(this.data.modelo);
    this.menajeriaForm.get(['menajeria','cantidad'])?.setValue(this.data.cantidad);
    this.menajeriaForm.get(['menajeria','razonSocial'])?.setValue(this.data.razonSocial);
    this.menajeriaForm.get(['menajeria','ruc'])?.setValue(this.data.ruc);
    this.menajeriaForm.get(['menajeria','numFactura'])?.setValue(this.data.numFactura);
    this.estado=this.data.estado;
    this.menajeriaId=this.data.id;
    console.log(this.estado);

    console.log(this.menajeriaForm)
  }

  createMenajeria(){
    const menajeria={
      nombre:this.menajeriaForm.value.menajeria.nombre,
      marca:this.menajeriaForm.value.menajeria.marca,
      modelo:this.menajeriaForm.value.menajeria.modelo,
      cantidad:this.menajeriaForm.value.menajeria.cantidad,
      factura:{
        razonSocial:this.menajeriaForm.value.menajeria.razonSocial,
        ruc:this.menajeriaForm.value.menajeria.ruc,
        numFactura:this.menajeriaForm.value.menajeria.numFactura
      }
    };
    console.log(this.menajeriaForm);
    console.log("menajeria")
    console.log(menajeria)
    this.almacenService.createMenajeria(menajeria).subscribe(data=>{
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Se agregó el artículo al almacén',
        showConfirmButton: false,
        timer: 4000
      });
      console.log("newMenajeria");
      console.log(data)
      this.dialogRef.close(1);
    })
  }

  updateMenajeria(){
    const menajeria={
      nombre:this.menajeriaForm.value.menajeria.nombre,
      marca:this.menajeriaForm.value.menajeria.marca,
      modelo:this.menajeriaForm.value.menajeria.modelo,
      cantidad:this.menajeriaForm.value.menajeria.cantidad,
      factura:{
        razonSocial:this.menajeriaForm.value.menajeria.razonSocial,
        ruc:this.menajeriaForm.value.menajeria.ruc,
        numFactura:this.menajeriaForm.value.menajeria.numFactura
      }
    };
    console.log(this.menajeriaForm);
    console.log("updatedMenajeria");
    console.log(menajeria);
    //console.log(this.equipoId);
    this.almacenService.updateMenajeria(this.menajeriaId,menajeria).subscribe(data=>{
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Se modificó el artículo',
        showConfirmButton: false,
        timer: 4000
      });
      console.log("updatedMenajeriaDone");
      console.log(data)
      this.dialogRef.close(1);
    })
  }


}
